import {
  getLabelFromMarkup,
  MeasurementsCapabilityProvider,
  pointPositionFormatter,
  Web3dTool,
} from '@trimble/web3d-providers';
import { SimpleMeasurementCapabilityBase } from './base-simple-measurement-capability';
import { createEffect, on } from 'solid-js';
import { detectArrayChanges } from '@trimble/utilities';
import { Web3DViewer } from '@technology/web3d';
import {
  Markup,
  MarkupPlugin,
  PointMarkup,
} from '@technology/web3d-plugin-markup';

export class PointMeasurementCapability extends SimpleMeasurementCapabilityBase {
  protected measurementType: Web3dTool = Web3dTool.PointMeasurement;

  constructor(measurementsProvider: MeasurementsCapabilityProvider) {
    super(measurementsProvider);

    createEffect(
      on(this.viewerWrappers, (viewerWrappers, previousViewerWrappers) => {
        const {
          newItems: newViewerWrappers,
          removedItems: removedViewerWrappers,
        } = detectArrayChanges(previousViewerWrappers, viewerWrappers);

        // Remove event listeners from removed viewers
        removedViewerWrappers.forEach((vw) => {
          this.removeAllViewerEventListeners(vw.viewer);
        });

        if (!newViewerWrappers.length) {
          return;
        }

        for (const vw of newViewerWrappers) {
          this.addEventListenersToViewer(vw.viewer);
        }
      })
    );
  }

  private addEventListenersToViewer(viewer: Web3DViewer): void {
    const markupAddedHandler = this.handleMarkupAdded(viewer);
    this.addViewerEventListener(viewer, 'markupadded', markupAddedHandler);
  }

  private readonly handleMarkupAdded =
    (viewer: Web3DViewer) =>
    (e: Event): void => {
      queueMicrotask(() => {
        const markupId = (e as CustomEvent<Markup>).detail.id;
        viewer.plugins
          .get(MarkupPlugin)
          ?.getMarkups()
          .forEach((markup) => {
            if (markup.id == markupId && markup.name == 'pointMarkup') {
              const label = getLabelFromMarkup(
                markup,
                this.measurementsProvider.items()
              );
              (markup as PointMarkup).positionFormatter = (position) =>
                pointPositionFormatter(
                  position,
                  viewer,
                  this.measurementsProvider.pointMeasurementSettings()
                    .showXYCoordinates,
                  this.measurementsProvider.pointMeasurementSettings()
                    .showZCoordinate,
                  label
                );
            }
          });
      });
    };
}
